import React from 'react'
import "./errorMessage.scss"
function ErrorMessage() {
    return (
        <div className='error-message'>Algo deu errado. Por favor, tente novamente!</div>
    )
}

export default ErrorMessage